import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { createTheme } from "react-data-table-component";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import { Icon } from "../../../components";
import DataTable from "react-data-table-component";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../../src/services/auth/api";

// const baseURL = "http://127.0.0.1:8000/api/";

function ProductList() {
  const [listData, setListData] = useState([]);
  const [page, setPage] = useState(0);
  const countPerPage = 5;
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getList = () => {
    setLoading(true);
    api
      .get(`${process.env.REACT_APP_HOST}api/products-get-all-paginated`, { params: { page } })
      .then((response) => {
        setListData(response.data.data.data);
        setTotalRows(response.data.data.pagination.total);
      })
      .catch(() => {
        setListData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getList();
  }, [page]);

  const handleView = (_id) => {
    navigate(`/shop/admin/product-view/${_id}`);
  };

  const handleEdit = (_id) => {
    navigate(`/shop/admin/product-edit/${_id}`);
  };

  const handleCreateVariant = (_id) => {
    navigate(`/shop/admin/product-variant/${_id}`);
  };

  const deleteError = () => {
    Swal.fire({
      icon: "error",
      title: "Delete attempt was not successful",
      text: "Something went wrong!",
    });
  };

  const deleteConfirm = (_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "It will delete permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`${process.env.REACT_APP_HOST}api/products/${_id}`)
          .then((response) => {
            if (response.data.success) {
              getList();
              Swal.fire(
                "Deleted",
                "You successfully deleted this record",
                "success"
              );
            } else {
              deleteError();
            }
          })
          .catch(deleteError);
      }
    });
  };

  createTheme("solarized", {
    text: {
      primary: "#004b8e",
      secondary: "#2aa198",
    },
    background: {
      default: "#fff",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#d3d3d3",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.02)",
      disabled: "rgba(0,0,0,.12)",
    },
  });

  const customStyles = {
    rows: {
      style: {
        minHeight: "45px",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e67a8",
        color: "#fff",
        fontSize: "14px",
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
  };

  const productListDataColumns = [
    {
      name: "Actions",
      cell: (row) => (
        <div className="text-start w-100">
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleView(row.id)}
          >
            View
          </Button>
          <Button
            variant="primary"
            size="sm"
            className="ms-2"
            onClick={() => handleEdit(row.id)}
          >
            Edit
          </Button>
          <Button
            variant="primary"
            size="sm"
            className="ms-2"
            onClick={() => handleCreateVariant(row.id)}
          >
            Create Product Variants
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => deleteConfirm(row.id)}
            className="ms-2"
          >
            Delete
          </Button>
        </div>
      ),
      sortable: false,
      hide: "md",
    },
    {
      name: "Title",
      selector: (row) => row.title,
      cell: (row) => <span>{row.title}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      cell: (row) => <span>{row.description}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Image",
      selector: (row) => row.image_url,
      cell: (row) => <span>{row.image_url}</span>,
      sortable: true,
      hide: "md",
    },
  ];

  return (
    <Layout title="Product List">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/admin/admin-panel"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <span>Go To Panel</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/admin-panel"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <span>Go To Panel</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
          <Block.HeadContent>
            <Block.Title tag="h2">Product List</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/product"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <Icon name="plus" />
                  <span>Create</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/product"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <Icon name="plus" />
                  <span>Create</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <DataTable
            tableClassName="data-table-head-light table-responsive"
            columns={productListDataColumns}
            data={listData}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={(page) => setPage(page - 1)}
            progressPending={loading}
            theme="solarized"
            customStyles={customStyles}
          />
        </Card>
      </Block>
    </Layout>
  );
}

export default ProductList;
